import { useEffect, useState } from 'react'
import { LAPTOP } from '../breakpoints'

export const useScreenWidth = () => {
  const [width, setWidth] = useState(LAPTOP)
  const resize = () => {
    setWidth(Math.min(window.screen?.width, window.innerWidth))
  }

  useEffect(() => {
    window.addEventListener('resize', resize)
    resize()

    return () => {
      window.removeEventListener('resize', resize)
    }
  }, [])

  return width
}
